/* eslint-disable import/prefer-default-export */
import * as Sentry from '@sentry/react';
import { logDevMessage } from 'utils/utils';

import createAxiosThunk from 'store/createAxiosThunk';
import * as selectAxios from '../config/selectAxios';
import * as selectConfig from '../config/selectConfig';
import * as selectAiSearch from './selectAiSearch';
import * as selectSpecialties from '../specialties/selectSpecialties';
import { AI_SEARCH_ENDPOINT } from './aiSearchConstants';
import { formatAiSearchPayload, formatAiSearchResponse } from './aiSearchUtils';

export const aiSearch = createAxiosThunk('aiSearch', async (args, thunkApi) => {
  const { getState, rejectWithValue } = thunkApi;

  const state = getState();
  const API_URL = selectConfig.apiUrl(state);
  const axios = selectAxios.axiosInstance(state);
  const input = selectAiSearch.searchInputValue(state);
  const aiSearchKey = selectAiSearch.aiSearchKey(state);
  const payload = formatAiSearchPayload({ content: input, aiSearchKey });
  const specialties = selectSpecialties.specialties(state);

  if (!payload) {
    logDevMessage(`Malformed payload from message - ${input}`);
    rejectWithValue();
  }

  const url = `${API_URL}/${AI_SEARCH_ENDPOINT}`;

  const res = await axios.post(url, payload);

  try {
    const formattedData = formatAiSearchResponse(res.data, specialties);
    return formattedData;
  } catch (e) {
    Sentry.captureException(e);
    throw e;
  }
});
